export const ATTRIBUTE_PANEL_WIDTH = 310;

export default (theme: Object) => ({
  root: {
    padding: '17px 20px 0 25px',
    boxSizing: 'border-box',
    // in mobile view the attribute panel floats
    [theme.breakpoints.down('sm')]: {
      background: theme.palette.neutrals.background,
      padding: '0 10px',
      boxShadow: '0px 0px 4px rgba(6, 6, 6, 0.39)',
      borderRadius: 5,
      position: 'fixed',
      left: 'calc(50% - 155px)',
      bottom: 0,
      width: ATTRIBUTE_PANEL_WIDTH,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      left: 0,
    },
  },
  header: {
    display: 'flex',
    minHeight: 40,
    alignItems: 'center',
    background: theme.palette.neutrals.background,
    [theme.breakpoints.down('sm')]: {
      minHeight: 0,
      height: 30,
    },
  },
  headerTitle: {
    flexGrow: '2',
  },
  headerTitleInput: {
    fontSize: 19,
    fontWeight: 600,
  },
  headerIcons: {
    display: 'flex',
    flexFlow: 'row',
  },
  content: {
    height: '100%',
    background: theme.palette.neutrals.background,
  },
});
